import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import withStyles from "isomorphic-style-loader/withStyles";
import {
	Button,
	Form,
	Table,
	Row,
	Col,
	Accordion,
	Card,
	OverlayTrigger,
	Popover,
	Modal,
	Image,
} from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Query } from "react-apollo";

import { FaCaretDown, FaCaretUp } from "react-icons/fa";

// style
import s from "./ViewBookingDetails.css";
import rs from "../../../storeCommon.css";

// helpers
import messages from "../../../../locale/messages";
import { capitalizeFirstLetter } from "../../../../helpers/capitalizeFirst";
import { bookingStatusLocale } from "../../../../helpers/bookingStatusLocale";
import { WEIGHT_FEE_DRIVER_SHARE } from "../../../../constants";
import { getDeliveryName } from "../../../../helpers/getDeliveryName";
import { wita } from "../../../../helpers/witaTime";
import { getAvatarUrl, getUiAvatarUrl } from "../../../../utils/getAvatarUrl";
import { api, storeImageUploadDir } from "../../../../config";
// components
import Link from "../../../Link";
import CurrencyConverter from "../../../CurrencyConverter";
import OrderItemThumbnail from "../../../Common/OrderItemThumbnail";
import ScamRiskBadge from "../../ScamRiskBadge/ScamRiskBadge";
// import FailedTransactionModal from '../../FailedTransactionModal';
// redux actions
import { openTransactionModal } from "../../../../actions/siteadmin/modalActions";
import { updatePayoutStatus } from "../../../../actions/siteadmin/Payout/updatePayout";
import deleteBooking from "../../../../actions/siteadmin/Booking/deleteBooking";
import restoreDeletedBooking from "../../../../actions/siteadmin/Booking/restoreDeletedBooking";
import adminUpdateBookingDriver from "../../../../actions/siteadmin/Booking/adminUpdateBookingDriver";
import adminUpdateBookingStatus from "../../../../actions/siteadmin/Booking/adminUpdateBookingStatus";
import updateBookingRiskReview from "../../../../actions/siteadmin/Booking/updateBookingRiskReview";
// images
import downArrow from "../../../../../public/StoreIcon/Dropdownwithcircle20x20.svg";
import upArrow from "../../../../../public/StoreIcon/Uparrowwithcircle20x20.svg";
import {
	FaArrowLeft,
	FaCheck,
	FaClock,
	FaHistory,
	FaInfoCircle,
	FaMapMarkerAlt,
	FaPauseCircle,
	FaPercentage,
	FaRoute,
	FaStar,
	FaStoreAlt,
	FaTicketAlt,
	FaUndo,
	FaUser,
} from "react-icons/fa";

import getDriversForReassign from "./adminGetDriversForReassign.gql";
import getBookingReviewsQuery from "./getBookingReviews.gql";
import StarRating from "../../../StarRating/StarRating";
import { toastr } from "react-redux-toastr";
import Select from "react-select";

export class ViewBookingDetails extends Component {
	static propTypes = {
		title: PropTypes.string.isRequired,
	};

	static defaultProps = {
		locale: "en-US",
		pageType: null,
	};

	constructor(props) {
		super(props);
		this.state = {
			collapseID: [],
			isDeleteConfirmModalOpen: false,
			deleteReson: "Trial or Test Booking",
			orderIdToDelete: "",
			isDeleting: false,
			isRestoreConfirmModalOpen: false,
			isRestoring: false,
			isHistoryModalOpen: false,
			isReassignModalOpen: false,
			selectedDriverId: "",
			isSpecialDeliveryDetailsOpen: false,
			isUserFareDetailsOpen: true,
			isShopFareDetailsOpen: false,
			isUpdatingRiskReview: false,
			isRiskDetailsModalOpen: false,
			isStatusModalOpen: false,
			selectedStatus: "",
			statusDriverId: "",
			isUpdatingStatus: false,
		};
		this.handleHoldPayout = this.handleHoldPayout.bind(this);
		this.isValueDefined = this.isValueDefined.bind(this);
		this.renderAmountInformation = this.renderAmountInformation.bind(this);
		this.renderInformation = this.renderInformation.bind(this);
		this.renderUserInformation = this.renderUserInformation.bind(this);
		this.toggleCollapse = this.toggleCollapse.bind(this);
		this.handleDeleteBookingConfirmation =
			this.handleDeleteBookingConfirmation.bind(this);
		this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this);
		this.handleDeleteBooking = this.handleDeleteBooking.bind(this);
		this.handleToggleSpecialDeliveryDetails =
			this.handleToggleSpecialDeliveryDetails.bind(this);
		this.renderSpecialDeliveryDetails =
			this.renderSpecialDeliveryDetails.bind(this);
		this.handleToggleUserFareDetails = this.handleToggleUserFareDetails.bind(
			this,
		);
		this.handleToggleUserFareDetails = this.handleToggleUserFareDetails.bind(
			this,
		);
		this.renderUserFare = this.renderUserFare.bind(this);
		this.handleToggleShopFareDetails = this.handleToggleShopFareDetails.bind(
			this,
		);
		this.renderShopFare = this.renderShopFare.bind(this);
		this.handleRestoreBookingConfirmation =
			this.handleRestoreBookingConfirmation.bind(this);
		this.handleCloseRestoreModal = this.handleCloseRestoreModal.bind(this);
		this.handleRestoreBooking = this.handleRestoreBooking.bind(this);
		this.handleOpenHistoryModal = this.handleOpenHistoryModal.bind(this);
		this.handleCloseHistoryModal = this.handleCloseHistoryModal.bind(this);
		this.handleReassignModalOpen = this.handleReassignModalOpen.bind(this);
		this.handleReassignModalClose = this.handleReassignModalClose.bind(this);
		this.handleReassignDriver = this.handleReassignDriver.bind(this);
		this.handleSelectDriver = this.handleSelectDriver.bind(this);
		this.handleStatusModalOpen = this.handleStatusModalOpen.bind(this);
		this.handleStatusModalClose = this.handleStatusModalClose.bind(this);
		this.handleUpdateBookingStatus = this.handleUpdateBookingStatus.bind(this);
		this.renderDriverSelect = this.renderDriverSelect.bind(this);
		this.renderOrderModifierGroups = this.renderOrderModifierGroups.bind(this);
		this.renderOrderedItems = this.renderOrderedItems.bind(this);
		this.handleRiskReview = this.handleRiskReview.bind(this);
		this.handleOpenRiskDetailsModal = this.handleOpenRiskDetailsModal.bind(this);
		this.handleCloseRiskDetailsModal = this.handleCloseRiskDetailsModal.bind(this);
	}

	isValueDefined(value) {
		if (value !== null && value !== undefined && value !== "") {
			return true;
		}
		return false;
	}

	renderAmountInformation({
		label,
		amount,
		currency,
		isMinus = false,
		isPlus = false,
		isBold = false,
		isGreen = false,
		isChildRow = false,
		afterContent = null,
	}) {
		if (label && this.isValueDefined(amount) && currency) {
			return (
				<tr className={amount <= 0 ? "text-muted" : ""}>
					<td className={cx({
						"pl-4": isChildRow
					})}>
						{isBold ? (
							<b>{label}</b>
						) :
							label
						}
					</td>
					{!isBold && (
						<td>
							<span className={cx({
								"text-danger": isMinus,
								"text-success": isPlus
							})}>
								{isMinus ? "-" : ""}
								{isPlus ? "+" : ""}
								<CurrencyConverter from={currency} amount={amount} />
								{afterContent ? `(${afterContent})` : ""}
							</span>
						</td>
					)}
					{isBold && (
						<td>
							<b className={cx({
								"text-bold": isBold,
								"text-success": isGreen,
							})}>
								{isMinus ? "-" : ""}
								<CurrencyConverter from={currency} amount={amount} />
								{afterContent ? `(${afterContent})` : ""}
							</b>
						</td>
					)}
				</tr>
			);
		}
	}

	renderInformation(label, information) {
		if (label && information) {
			return (
				<tr>
					<td className={s.tableLabelColumn}>
						<b>{label}</b>
					</td>
					<td className={s.lineBreak}>{information}</td>
				</tr>
			);
		}
	}

	renderDropOffMapLink(booking) {
		const { formatMessage } = this.props.intl;
		const googleMapURL = `https://maps.google.com/?q=${booking.dropOffLat},${booking.dropOffLng}`;
		return (
			<tr>
				<td className={s.tableLabelColumn}>
					<b>{formatMessage(messages.dropLocation)}</b>
				</td>
				<td className={s.lineBreak}>
					<div className="">
						<FaMapMarkerAlt
							className="text-danger mr-1"
							style={{ width: "1em", height: "1em" }}
						/>
						<a href={googleMapURL} target="_blank" rel="noreferrer">
							{booking.dropOffLocation}
						</a>
					</div>
				</td>
			</tr>
		);
	}

	// Feeds the early-completion penalty in driver dispatch.
	renderCompletionLocation(booking) {
		const { formatMessage } = this.props.intl;
		const distance = booking.completionDistanceMeters;
		if (booking.completionLat == null || booking.completionLng == null) return null;

		const googleMapURL = `https://maps.google.com/?q=${booking.completionLat},${booking.completionLng}`;
		const distanceText = distance == null
			? "Unknown distance"
			: distance < 1000 ? `${distance} m` : `${(distance / 1000).toFixed(1)} km`;

		return (
			<tr>
				<td className={s.tableLabelColumn}>
					<b>{formatMessage(messages.completedFromDropOff)}</b>
				</td>
				<td className={s.lineBreak}>
					<a href={googleMapURL} target="_blank" rel="noreferrer">
						{`${distanceText} from the drop-off`}
					</a>
				</td>
			</tr>
		);
	}

	renderPickUpMapLink(booking) {
		const { formatMessage } = this.props.intl;
		const googleMapURL = `https://maps.google.com/?q=${booking.pickUpLat},${booking.pickUpLng}`;
		return (
			<tr>
				<td className={s.tableLabelColumn}>
					<b>{formatMessage(messages.pickUpLocation)}</b>
				</td>
				<td className={s.lineBreak}>
					<div className="">
						<FaMapMarkerAlt
							className="text-danger mr-1 border-box"
							style={{ width: "1em", height: "1em" }}
						/>
						<a href={googleMapURL} target="_blank" rel="noreferrer">
							{booking.pickUpLocation}
						</a>
					</div>
				</td>
			</tr>
		);
	}

	renderMapDirectionLink(booking) {
		const { formatMessage } = this.props.intl;
		const startPoint = `${booking.pickUpLat},${booking.pickUpLng}`;
		const destinationPoint = `${booking.dropOffLat},${booking.dropOffLng}`;
		const mapDirectionUrl = `https://www.google.com/maps/dir/${startPoint}/${destinationPoint}/`;
		const distanceUnit =
			booking.distanceType === "km"
				? formatMessage(messages.kmLabel)
				: formatMessage(messages.milesLabel);

		return (
			<tr>
				<td className={s.tableLabelColumn}>
					<b>{formatMessage(messages.totalRideDistance)}</b>
				</td>
				<td className={s.lineBreak}>
					<div className="">
						<FaRoute
							className="text-danger mr-1 border-box"
							style={{ width: "1em", height: "1em" }}
						/>
						<span>
							{booking.totalDistance} {distanceUnit}{" "}
						</span>
						(
						<a
							href={mapDirectionUrl}
							target="_blank"
							className="btn btn-link btn-sm"
							rel="noreferrer"
						>
							View Route
						</a>
						)
					</div>
				</td>
			</tr>
		);
	}

	renderUserInformation(label, information, userType) {
		if (label && information) {
			const customerFullName = capitalizeFirstLetter(
				`${information.firstName} ${information.lastName}`,
			);
			const shopName = capitalizeFirstLetter(information.shopName);
			const renderName = userType !== 3 ? customerFullName : shopName;
			const detailLink = userType === 3
				? `/siteadmin/store/edit/${information.profileId}`
				: `/siteadmin/users/${information.profileId}`;
			const avatarUrl = information.picture
				? (userType === 3
					? `${api.apiEndpoint}${storeImageUploadDir}${information.picture}`
					: getAvatarUrl(information.picture))
				: getUiAvatarUrl(renderName);

			return (
				<tr>
					<td>
						<b>{label}</b>
					</td>
					<td className="d-flex align-items-center">
						<img
							src={avatarUrl}
							alt="avatar"
							style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', marginRight: 12, flexShrink: 0 }}
						/>
						<div>
							<Link to={detailLink}>{renderName}</Link>
							<br />
							{information.phoneNumber}
							<br />
							{information.email}
						</div>
					</td>
				</tr>
			);
		}
	}

	handleHoldPayout(e, id, fieldName) {
		const { updatePayoutStatus, refetch } = this.props;
		let isHold = e.target.value;
		isHold = isHold === "true";
		updatePayoutStatus(id, isHold, fieldName);
		refetch(id);
	}

	toggleCollapse(id1, id2) {
		const { collapseID } = this.state;
		const index = collapseID.indexOf(`${id1}.${id2}`);
		if (index > -1) {
			collapseID.splice(index, 1);
			this.setState({ collapseID });
		} else {
			collapseID.push(`${id1}.${id2}`);
			this.setState({ collapseID });
		}
	}

	renderBookingStatusBadge(bookingStatus, deliveryPartnerDetails) {
		const { locale } = this.props.intl;

		if (
			bookingStatus === "readyForDelivery" &&
			deliveryPartnerDetails !== null
		) {
			bookingStatus = "driverFound";
		}
		const className = cx({
			"badge badge-primary": [
				"approved",
				"deliveryApproved",
				"deliveryConfirmed",
				"driverFound",
				"readyForDelivery",
			].includes(bookingStatus),
			"badge badge-warning": ["pending", "startDelivery"].includes(
				bookingStatus,
			),
			"badge badge-success": ["completed"].includes(bookingStatus),
			"badge badge-danger": ["declined", "failed", "deliveryNotFound"].includes(
				bookingStatus,
			),
			"badge badge-secondary": [
				"cancelledByUser",
				"cancelledByPartner",
				"expired",
				"cancelledByDelivery",
			].includes(bookingStatus),
		});

		const iconStatus = {
			completed: <FaCheck className="mr-1" />,
			pending: <FaPauseCircle className="mr-1" />,
			startDelivery: <FaPauseCircle className="mr-1" />,
			expired: <FaClock className="mr-1" />,
		};

		return (
			<span className={className}>
				{iconStatus[bookingStatus]}
				{bookingStatusLocale(bookingStatus, locale)}
			</span>
		);
	}

	renderPaymentMethod(paymentMethod) {
		const { formatMessage } = this.props.intl;
		const paymentMethods = {
			1: formatMessage(messages.cashOnHand),
			2: formatMessage(messages.card),
			3: formatMessage(messages.wallet),
			4: "QRIS",
		};

		return paymentMethods[paymentMethod] || "";
	}

	renderPaymenetStatus(paymentStatus) {
		const { formatMessage } = this.props.intl;
		const className = cx({
			"text-warning": paymentStatus === "pending",
			"text-success": paymentStatus === "completed",
		});

		const statusText = (
			<span className={className}>
				{paymentStatus === "pending"
					? formatMessage(messages.notPaidLabel)
					: formatMessage(messages.paidLabel)}
			</span>
		);

		return statusText;
	}

	renderScamRiskDetails(scamRisk) {
		if (!scamRisk) {
			return null;
		}

		return (
			<tr>
				<td className={s.tableLabelColumn}>
					<b>Scam Risk</b>
				</td>
				<td>
					<ScamRiskBadge risk={scamRisk} showScore />
					<br />
					<Button
						size="sm"
						variant="link"
						className="mt-2 p-0"
						onClick={this.handleOpenRiskDetailsModal}
					>
						See Details
					</Button>
				</td>
			</tr>
		);
	}

	renderScamRiskModal(scamRisk) {
		if (!scamRisk) {
			return null;
		}

		const reasons = scamRisk && scamRisk.reasons ? scamRisk.reasons : [];
		const isUpdating = this.state.isUpdatingRiskReview;

		return (
			<Modal
				show={this.state.isRiskDetailsModalOpen}
				onHide={this.handleCloseRiskDetailsModal}
				size="lg"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Scam Risk Details</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						<ScamRiskBadge risk={scamRisk} showScore />
					</div>
					<div className={s.scamRiskMeta}>
						{scamRisk.reviewedAt && <span>Reviewed: {wita(scamRisk.reviewedAt)?.format("DD-MM-YYYY HH:mm")}</span>}
					</div>
					{reasons.length > 0 && (
						<ul className={s.scamRiskReasons}>
							{reasons.map(reason => (
								<li key={`${reason.code}-${reason.points}`}>
									<span>{reason.detail}</span>
									<strong>+{reason.points}</strong>
								</li>
							))}
						</ul>
					)}
					{reasons.length === 0 && (
						<p className="text-muted mb-0">No risk reasons available.</p>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						onClick={this.handleCloseRiskDetailsModal}
						disabled={isUpdating}
					>
						Close
					</Button>
					<Button
						variant="outline-success"
						disabled={isUpdating || scamRisk.reviewStatus === "false_positive"}
						onClick={() => this.handleRiskReview("false_positive")}
					>
						False Positive
					</Button>
					<Button
						variant="danger"
						disabled={isUpdating || scamRisk.reviewStatus === "confirmed_scam"}
						onClick={() => this.handleRiskReview("confirmed_scam")}
					>
						Confirm Scam
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	handleOpenRiskDetailsModal() {
		this.setState({ isRiskDetailsModalOpen: true });
	}

	handleCloseRiskDetailsModal() {
		this.setState({ isRiskDetailsModalOpen: false });
	}

	async handleRiskReview(reviewStatus) {
		const { data, refetch, updateBookingRiskReview } = this.props;
		const bookingId = data?.result?.id;

		if (!bookingId) {
			return;
		}

		this.setState({ isUpdatingRiskReview: true });
		const result = await updateBookingRiskReview(bookingId, reviewStatus);

		if (result && result.status === 200 && refetch) {
			await refetch();
		}

		this.setState({ isUpdatingRiskReview: false });
	}

	handleDeleteBookingConfirmation(e) {
		this.setState({
			isDeleteConfirmModalOpen: true,
		});
	}

	handleCloseDeleteModal(e) {
		this.setState({
			isDeleteConfirmModalOpen: false,
		});
	}

	async handleDeleteBooking(e) {
		const { data, deleteBooking, refetch } = this.props;
		const { deleteReson, deleteReason } = this.state;
		const orderId = data.result.orderId;
		let finalReason = deleteReson;
		if (deleteReson === "Other") {
			finalReason = deleteReason;
		}

		this.setState({ isDeleting: true });

		const result = await deleteBooking(orderId, finalReason);

		if (result && result.status === 200) {
			await refetch();
		}

		this.setState({
			isDeleteConfirmModalOpen: false,
			isDeleting: false,
		});
	}

	handleRestoreBookingConfirmation() {
		this.setState({
			isRestoreConfirmModalOpen: true,
		});
	}

	handleCloseRestoreModal() {
		this.setState({
			isRestoreConfirmModalOpen: false,
		});
	}

	async handleRestoreBooking() {
		const { data, restoreDeletedBooking, refetch } = this.props;
		const orderId = data.result.orderId;

		this.setState({ isRestoring: true });

		const result = await restoreDeletedBooking(orderId);
		if (result && result.status === 200) {
			await refetch();
		}

		this.setState({
			isRestoreConfirmModalOpen: false,
			isRestoring: false,
		});
	}

	handleOpenHistoryModal() {
		this.setState({ isHistoryModalOpen: true });
	}

	handleCloseHistoryModal() {
		this.setState({ isHistoryModalOpen: false });
	}

	handleReassignModalOpen() {
		this.setState({ isReassignModalOpen: true });
	}

	handleReassignModalClose() {
		this.setState({ isReassignModalOpen: false, selectedDriverId: "" });
	}

	handleSelectDriver(e) {
		this.setState({ selectedDriverId: e.target.value });
	}

	handleReassignDriver() {
		const selectedDriverId = this.state.selectedDriverId;
		const { data, refetch, adminUpdateBookingDriver } = this.props;
		const bookingId = data?.result?.id;

		const toastrConfirmOptions = {
			okText: "Yes, Sure!",
			cancelText: "Cancel",
			onOk: async () => {
				console.log("OK: clicked", selectedDriverId, bookingId);
				const result = await adminUpdateBookingDriver(bookingId, selectedDriverId);
				if (result && result.status === 200) {
					await refetch();
				}
			},
			onCancel: () => console.log("CANCEL: clicked"),
		};
		toastr.confirm("Are you sure to reassign driver?", toastrConfirmOptions);
		this.handleReassignModalClose();
	}

	handleStatusModalOpen() {
		const bookingData = this.props.data?.result;
		this.setState({
			isStatusModalOpen: true,
			selectedStatus: "",
			statusDriverId: bookingData?.deliveryPartnerId || "",
		});
	}

	handleStatusModalClose() {
		this.setState({
			isStatusModalOpen: false,
			selectedStatus: "",
			statusDriverId: "",
		});
	}

	async handleUpdateBookingStatus() {
		const { selectedStatus, statusDriverId } = this.state;
		const { data, refetch, adminUpdateBookingStatus } = this.props;
		const bookingId = data?.result?.id;

		this.setState({ isUpdatingStatus: true });

		const result = await adminUpdateBookingStatus(
			bookingId,
			selectedStatus,
			selectedStatus === "completed" ? statusDriverId : null,
		);

		this.setState({ isUpdatingStatus: false });

		// Keep the modal open on failure so the admin can retry or adjust.
		if (result && result.status === 200) {
			this.handleStatusModalClose();
			if (refetch) {
				await refetch();
			}
		}
	}

	// Shared by the reassign modal and the change-status modal.
	renderDriverSelect({ value, onChange, showCurrentDriverCard = false }) {
		const bookingData = this.props.data?.result;

		return (
			<Query
				query={getDriversForReassign}
				variables={{
					// Optional: this object is built every render, not when the
					// modal opens, so a booking the query could not resolve
					// (result: null) crashed the whole page here.
					locationId: bookingData?.locationId,
				}}
			>
				{({ loading, error, data }) => {
					if (loading) return <p>Loading drivers...</p>;
					if (error)
						return (
							<div className="alert alert-danger">Error loading drivers.</div>
						);
					const drivers = data.adminGetDriversForReassign
						? data.adminGetDriversForReassign.results
						: [];

					const driverLabel = (driver) =>
						`${driver.profile.firstName} ${driver.profile.lastName} (${driver.phoneNumber})`;

					let displayedDriver = null;

					if (value) {
						const selected = drivers.find((d) => d.id === value);
						if (selected) {
							displayedDriver = {
								firstName: selected.profile.firstName,
								lastName: selected.profile.lastName,
								phoneNumber: selected.phoneNumber,
								picture: selected.profile.picture,
							};
						} else if (bookingData?.deliveryPartnerDetails) {
							displayedDriver = bookingData.deliveryPartnerDetails;
						}
					} else if (bookingData?.deliveryPartnerDetails) {
						displayedDriver = bookingData.deliveryPartnerDetails;
					}

					const selectedDriver = drivers.find((d) => d.id === value);

					return (
						<Form.Group>
							{showCurrentDriverCard && displayedDriver && (
								<div className="d-flex align-items-center mb-4 p-3 bg-light rounded">
									<Image
										src={
											displayedDriver.picture
												? getAvatarUrl(displayedDriver.picture)
												: getUiAvatarUrl(displayedDriver.firstName)
										}
										width={50}
										height={50}
										roundedCircle
										className="mr-3"
									/>
									<div>
										<div className="font-weight-bold">
											{displayedDriver.firstName} {displayedDriver.lastName}
										</div>
										<div className="text-muted small">
											{displayedDriver.phoneNumber}
										</div>
									</div>
								</div>
							)}
							<Form.Label>Select Driver</Form.Label>
							<Select
								options={drivers.map((driver) => ({
									label: driverLabel(driver),
									value: driver.id,
								}))}
								value={
									value
										? {
											label: selectedDriver
												? driverLabel(selectedDriver)
												: (displayedDriver
													? `${displayedDriver.firstName} ${displayedDriver.lastName}`
													: ""),
											value,
										}
										: null
								}
								onChange={(selectedOption) => {
									onChange(selectedOption ? selectedOption.value : "");
								}}
								isClearable={true}
								placeholder="Select a driver..."
								menuPortalTarget={
									typeof document !== "undefined" ? document.body : null
								}
								styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
							/>
						</Form.Group>
					);
				}}
			</Query>
		);
	}

	renderStatusModal(bookingData) {
		const { locale } = this.props.intl;
		const { selectedStatus, statusDriverId, isUpdatingStatus } = this.state;

		// Must stay in sync with ALLOWED_STATUSES in adminUpdateBookingStatus.js
		const statusOptions = [
			"completed",
			"failed",
			"deliveryNotFound",
			"cancelledByDelivery",
			"expired",
		]
			.filter((status) => status !== bookingData?.bookingStatus)
			.map((status) => ({
				label: `${bookingStatusLocale(status, locale)} (${status})`,
				value: status,
			}));

		const isDriverMissing = selectedStatus === "completed" && !statusDriverId;

		return (
			<Modal
				show={this.state.isStatusModalOpen}
				onHide={this.handleStatusModalClose}
				enforceFocus={false}
			>
				<Modal.Header closeButton>
					<Modal.Title>
						Change Status for Booking #{bookingData?.orderId}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group>
						<Form.Label>Current Status</Form.Label>
						<div>
							{this.renderBookingStatusBadge(
								bookingData?.bookingStatus,
								bookingData?.deliveryPartnerDetails,
							)}
						</div>
					</Form.Group>

					<Form.Group>
						<Form.Label>New Status</Form.Label>
						<Select
							options={statusOptions}
							value={
								statusOptions.find((option) => option.value === selectedStatus) ||
								null
							}
							onChange={(selectedOption) => {
								this.setState({
									selectedStatus: selectedOption ? selectedOption.value : "",
								});
							}}
							isClearable={true}
							placeholder="Select a status..."
							menuPortalTarget={
								typeof document !== "undefined" ? document.body : null
							}
							styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
						/>
					</Form.Group>

					{selectedStatus === "completed" && (
						<>
							{this.renderDriverSelect({
								value: statusDriverId,
								onChange: (driverId) => this.setState({ statusDriverId: driverId }),
							})}
						</>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={this.handleStatusModalClose}>
						Close
					</Button>
					<Button
						variant="primary"
						onClick={this.handleUpdateBookingStatus}
						disabled={!selectedStatus || isDriverMissing || isUpdatingStatus}
					>
						{isUpdatingStatus ? "Updating..." : "Confirm Change"}
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	renderHistoryModal(bookingData) {
		const histories = bookingData.bookingHistories || [];
		return (
			<Modal
				show={this.state.isHistoryModalOpen}
				onHide={this.handleCloseHistoryModal}
				size="lg"
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<FaHistory className="mr-1" /> Booking Activities
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{histories.length === 0 ? (
						<p className="text-center text-muted">No history available.</p>
					) : (
						<ul className={s.timeline}>
							{histories.map((history, index) => (
								<li key={history.id} className="timeline-item">
									<div className="d-flex justify-content-between align-items-center mb-2">
										<div>
											<h6 className="mb-0 font-weight-bold">
												{history.bookingStatus}
											</h6>
											<small className="text-muted">
												({wita(history.updatedAt)?.fromNow()})
											</small>
										</div>
										<div>
											<small className="text-muted">
												{wita(history.createdAt)?.format(
													"DD MMM YYYY, HH:mm:ss",
												)}
											</small>
										</div>
									</div>
									<p className="mb-0 text-secondary">{history.notes}</p>
								</li>
							))}
						</ul>
					)}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={this.handleCloseHistoryModal}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}

	renderOrderedItems(bookingData) {
		if (
			!bookingData ||
			!bookingData.orderItemDetails ||
			bookingData.orderItemDetails.length === 0
		) {
			return null;
		}

		return (
			<tr>
				<td>
					<b>
						<FormattedMessage {...messages.orderedItems} />
					</b>
				</td>
				<td>
					{bookingData.orderItemDetails.map((orderItem, orderKey) => {
						return (
							<div key={orderItem.id}>
								<div className="d-flex align-items-center">
									<OrderItemThumbnail
										image={orderItem.image}
										name={orderItem.itemName}
									/>
									<p
										className={cx(s.noMargin, s.paddingTop, {
											[s.noMargin]:
												bookingData.orderItemDetails.length - 1 === orderKey,
										})}
									>
										<span
											className={cx(
												s.orderItem,
												"viewItemOrderRTL",
												"disPlayInlineRTL",
											)}
										>
											{orderItem.quantity} x{" "}
										</span>
										<span className={cx(s.orderText, "disPlayInlineRTL")}>
											{orderItem.itemName}
										</span>
										{": "}
	
										<div
											style={{
												display: "flex",
												justifyContent: "space-between",
												flexDirection: "column",
											}}
										>
											<span
												style={
													orderItem.totalWithDiscount
														? {
															textDecoration: "line-through",
															color: "#888",
															fontSize: "14px",
															fontStyle: "italic",
														}
														: {}
												}
											>
												<CurrencyConverter
													from={bookingData.currency}
													amount={orderItem.total}
												/>
											</span>
											{orderItem.totalWithDiscount && (
												<CurrencyConverter
													from={bookingData.currency}
													amount={orderItem.totalWithDiscount}
												/>
											)}
										</div>
									</p>
								</div>

								{this.renderOrderModifierGroups(orderItem, orderKey)}
							</div>
						);
					})}
				</td>
			</tr>
		);
	}

	renderOrderModifierGroups(orderItem, orderKey) {
		const { collapseID } = this.state;

		if (
			!orderItem.orderModifierGroup ||
			orderItem.orderModifierGroup.length === 0
		) {
			return null;
		}

		return orderItem.orderModifierGroup.map(
			(orderModifierGroup, orderModifierGroupKey) => {
				return (
					<div
						className="orderAccordion adminEarning orderAccordionAdmin"
						key={orderModifierGroup.id}
					>
						<Accordion defaultActiveKey="0">
							<Card>
								<Card.Header>
									<Accordion.Toggle
										variant="link"
										eventKey="1"
										className={cx("arrowBtn", s.displayTable)}
										onClick={() =>
											this.toggleCollapse(orderKey, orderModifierGroupKey)
										}
									>
										<span className={cx(s.displayTableCell, s.mobDisplayTable)}>
											<img
												src={
													collapseID.includes(
														`${orderKey}.${orderModifierGroupKey}`,
													)
														? upArrow
														: downArrow
												}
												alt="arrow icon"
											/>
										</span>
										<span
											className={cx(
												s.choicsContent,
												s.displayTableCell,
												"choicsContentRTL",
											)}
										>
											{orderModifierGroup.modifierName} &nbsp;
											{orderModifierGroup.total > 0 &&
												orderModifierGroup.total.toFixed(2) >= 0.01 && (
													<CurrencyConverter
														from={orderModifierGroup.currency}
														amount={orderModifierGroup.total}
													/>
												)}
										</span>
									</Accordion.Toggle>
								</Card.Header>
								<Accordion.Collapse eventKey="1">
									<Card.Body>
										{orderModifierGroup.orderModifierItem &&
											orderModifierGroup.orderModifierItem.length > 0 &&
											orderModifierGroup.orderModifierItem.map(
												(itemData, key) => {
													return (
														<div key={itemData.id}>
															<span
																className={cx(
																	s.orderItem,
																	s.displayTableCell,
																	s.orderWidth,
																	"orderViewItemRTL",
																	"disPlayInlineRTL",
																)}
															>
																{itemData.quantity} x
															</span>
															<span
																className={cx(
																	s.itemBottom,
																	s.displayTableCell,
																	"itemBottomRTL",
																)}
															>
																{itemData.modifierItemName}
																{itemData.modifierItemPrice &&
																	itemData.modifierItemPrice.toFixed(2) >=
																	0.01 && (
																		<span>
																			{" "}
																			- (
																			<CurrencyConverter
																				from={itemData.currency}
																				amount={itemData.modifierItemPrice}
																			/>
																			)
																		</span>
																	)}
															</span>
														</div>
													);
												},
											)}
									</Card.Body>
								</Accordion.Collapse>
							</Card>
						</Accordion>
					</div>
				);
			},
		);
	}

	renderPromoCodeLink(promoCode) {
		return (
			<OverlayTrigger
				trigger={["hover", "focus"]}
				key={"voucher-promo-code-info"}
				placement={"top"}
				overlay={
					<Popover id={`voucher-promo-code-info`}>
						<Popover.Title as="h3">
							{promoCode.title}
						</Popover.Title>
						<Popover.Content>
							Promo Variant: {promoCode.variant}
							<br />
							Discount value:{" "}
							{promoCode.type === 1 ? (
								`${promoCode.promoValue}%`
							) : (
								<CurrencyConverter
									from={promoCode.currency}
									amount={
										promoCode.promoValue
									}
								/>
							)}<br />
							Max Value: {promoCode.maxValue}
						</Popover.Content>
					</Popover>
				}
			>
				<Link
					to={`/siteadmin/promo-code/edit/${promoCode.promoId}`}
				>
					<span className="ml-2 badge badge-light">
						<FaTicketAlt /> {promoCode.code}
					</span>
				</Link>
			</OverlayTrigger>
		)
	}

	handleToggleSpecialDeliveryDetails() {
		this.setState({
			isSpecialDeliveryDetailsOpen:
				!this.state.isSpecialDeliveryDetailsOpen,
		});
	}

	handleToggleUserFareDetails() {
		this.setState({
			isUserFareDetailsOpen: !this.state.isUserFareDetailsOpen,
		});
	}

	handleToggleShopFareDetails() {
		this.setState({
			isShopFareDetailsOpen: !this.state.isShopFareDetailsOpen,
		});
	}

	renderShopFare(bookingData) {
		const { formatMessage } = this.props.intl;
		return (
			<>
				<tr
					onClick={this.handleToggleShopFareDetails}
					style={{ cursor: "pointer" }}
				>
					<td>
						<b>{formatMessage(messages.shopTotalFare)}</b>
						{this.state.isShopFareDetailsOpen ? (
							<FaCaretUp className="ml-2" />
						) : (
							<FaCaretDown className="ml-2" />
						)}
					</td>

					<td>
						<b>
							+
							<CurrencyConverter
								from={bookingData.currency}
								amount={bookingData.shopTotalFare}
							/>
						</b>
					</td>
				</tr>

				{this.state.isShopFareDetailsOpen && (
					<>
						{this.renderAmountInformation({
							label: formatMessage(messages.shopFee),
							amount: bookingData.shopServiceFare,
							currency: bookingData.currency,
							isMinus: false,
							isChildRow: true,
						})}
						{this.renderAmountInformation({
							label: "Packaging Fee",
							amount: bookingData.packagingFee,
							currency: bookingData.currency,
							isChildRow: true,
						})}
					</>
				)}
			</>
		);
	}

	renderUserFare(bookingData) {
		const { formatMessage } = this.props.intl;
		const userTotalFare = bookingData.userTotalFare - bookingData.subTotal;
		return (
			<>
				<tr
					onClick={this.handleToggleUserFareDetails}
					style={{ cursor: "pointer" }}
				>
					<td>
						<b>
							{formatMessage(messages.userTotalFare)}{" "}
							{this.state.isUserFareDetailsOpen ? (
								<FaCaretUp className="ml-2" />
							) : (
								<FaCaretDown className="ml-2" />
							)}
						</b>
					</td>

					<td>
						<b>
							+
							<CurrencyConverter
								from={bookingData.currency}
								amount={userTotalFare}
							/>
						</b>
					</td>
				</tr>

				{this.state.isUserFareDetailsOpen && (
					<>
						{bookingData.deliveryFee > 0 && (
							<tr>
								<td className="pl-4">{formatMessage(messages.deliveryFee)}</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.deliveryFee}
									/>
								</td>
							</tr>
						)}
						{bookingData.tips > 0 && (
							<tr>
								<td className="pl-4">{formatMessage(messages.tipsAmount)}</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.tips}
									/>
								</td>
							</tr>
						)}
						{this.isValueDefined(bookingData.userServiceFare) && (
							<tr>
								<td className="pl-4">
									{formatMessage(messages.userServiceFee)}
								</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.userServiceFare}
									/>
								</td>
							</tr>
						)}
						{bookingData.deliveryName !== 'Food' && this.isValueDefined(bookingData.weightFee) && (
							<tr className={bookingData.weightFee <= 0 ? "text-muted" : ""}>
								<td className="pl-4">Weight Fee</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.weightFee}
									/>
								</td>
							</tr>
						)}
						{this.isValueDefined(bookingData.packagingFee) && (
							<tr>
								<td className="pl-4">Packaging Fee</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.packagingFee}
									/>
								</td>
							</tr>
						)}
						{this.isValueDefined(bookingData.parkingFee) && (
							<tr>
								<td className="pl-4">Parking Fee</td>
								<td>
									<CurrencyConverter
										from={bookingData.currency}
										amount={bookingData.parkingFee}
									/>
								</td>
							</tr>
						)}
					</>
				)
				}
			</>
		);
	}

	renderSpecialDeliveryDetails(bookingData) {
		const { formatMessage } = this.props.intl;
		if (
			bookingData.isSpecialDelivery !== 1 ||
			bookingData.specialDeliveryFare <= 0
		) {
			return null;
		}

		return (
			<>
				<tr
					onClick={this.handleToggleSpecialDeliveryDetails}
					style={{ cursor: "pointer" }}
				>
					<td>
						<b>Discounts</b>
						{this.state.isSpecialDeliveryDetailsOpen ? (
							<FaCaretUp className="ml-2" />
						) : (
							<FaCaretDown className="ml-2" />
						)}
					</td>
					<td>
						<b className="text-danger">
							-
							<CurrencyConverter
								from={bookingData.currency}
								amount={bookingData.specialDeliveryFare}
							/>
						</b>
						{this.renderPromoCodeLink(bookingData.promoCode)}
					</td>
				</tr>

				{this.state.isSpecialDeliveryDetailsOpen && (
					<>
						<tr>
							<td className="pl-4">Booking Fee Discount</td>
							<td>
								-
								<CurrencyConverter
									from={bookingData.currency}
									amount={bookingData.bookingFeeDiscount}
								/>
							</td>
						</tr>

						<tr>
							<td className="pl-4">Delivery Fee Discount</td>
							<td>
								-
								<CurrencyConverter
									from={bookingData.currency}
									amount={bookingData.deliveryFeeDiscount}
								/>
							</td>
						</tr>
					</>
				)}
			</>
		);
	}

	render() {
		const { title, data, pageType, openTransactionModal, listSearch } = this.props;
		const { formatMessage, locale } = this.props.intl;

		// listSearch carries the search and filters of the list the admin came
		// from, so going back lands on that same result set.
		let goToBackLink = `/siteadmin/bookings${listSearch || ""}`;
		if (pageType !== "bookings") {
			goToBackLink = `/siteadmin/${pageType}${listSearch || ""}`;
		}

		const bookingData = data && data.result;

		let adminEarnings = 0,
			adminOverdraft = 0,
			driverEarnings = 0;
		let currentWeightFeeDriverShare = WEIGHT_FEE_DRIVER_SHARE;
		if (bookingData) {
			const expectedWithoutWeightFee = Number(bookingData.deliveryFee || 0) - Number(bookingData.driverServiceFare || 0) + Number(bookingData.parkingFee || 0);
			const actualWeightFeeInDriverTotal = Number(bookingData.driverTotalFare || 0) - expectedWithoutWeightFee;
			const isOldBooking = bookingData.weightFee > 0 && Math.abs(actualWeightFeeInDriverTotal - Number(bookingData.weightFee)) < 10;
			currentWeightFeeDriverShare = isOldBooking ? 1 : WEIGHT_FEE_DRIVER_SHARE;

			// Admin earnings comes from the server (companyBookingDeposit snapshot,
			// with a fallback for legacy bookings) so this always matches the
			// bookings list column. See adminEarnings.helper.js on the server.
			const netPlatformEarnings = Number(bookingData.adminEarnings || 0);
			adminEarnings = netPlatformEarnings > 0 ? netPlatformEarnings : 0;
			adminOverdraft = netPlatformEarnings < 0 ? Math.abs(netPlatformEarnings) : 0;

			driverEarnings =
				expectedWithoutWeightFee +
				Number(bookingData.tips || 0) +
				(bookingData.deliveryName !== "Food"
					? Number(bookingData.weightFee || 0) * currentWeightFeeDriverShare
					: 0);
		}


		return (
			<>
				<Modal
					show={this.state.isDeleteConfirmModalOpen}
					onHide={this.handleCloseDeleteModal}
				>
					<Modal.Header>
						<Modal.Title>Delete Confirmation</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>Delete Reason:</p>
						<Form>
							<div className="mb-3">
								<Form.Check
									inline
									label="Trial or Test Booking"
									name="deleteReson"
									type={"radio"}
									id={`inline-radio-1`}
									value="Trial or Test Booking"
									checked={this.state.deleteReson === "Trial or Test Booking"}
									onChange={(e) =>
										this.setState({ deleteReson: e.target.value })
									}
								/>
								<br />
								<Form.Check
									inline
									label="Out of stock from Shop"
									name="deleteReson"
									type={"radio"}
									id={`inline-radio-2`}
									value="Out of stock from Shop"
									checked={this.state.deleteReson === "Out of stock from Shop"}
									onChange={(e) =>
										this.setState({ deleteReson: e.target.value })
									}
								/>
								<br />
								<Form.Check
									inline
									label="Booking not delivered"
									name="deleteReson"
									type={"radio"}
									id={`inline-radio-3`}
									value="Booking not delivered"
									checked={this.state.deleteReson === "Booking not delivered"}
									onChange={(e) =>
										this.setState({ deleteReson: e.target.value })
									}
								/>
								<br />
								<Form.Check
									inline
									label="Other"
									name="deleteReson"
									type={"radio"}
									id={`inline-radio-4`}
									value="Other"
									checked={this.state.deleteReson === "Other"}
									onChange={(e) =>
										this.setState({ deleteReson: e.target.value })
									}
								/>
							</div>
							<textarea
								className={cx("form-control mb-2", {
									"d-none": this.state.deleteReson !== "Other",
								})}
								name="deleteReason"
								id="deleteReason"
								cols="30"
								rows="5"
								placeholder="delete reason..."
								onChange={(e) =>
									this.setState({ deleteReason: e.target.value })
								}
							></textarea>
						</Form>

						<p>
							Enter Order ID to delete this booking:{" "}
							<code>{bookingData?.orderId}</code>
						</p>
						<input
							type="text"
							className="form-control"
							placeholder="Order ID to be deleted"
							onChange={(e) =>
								this.setState({ orderIdToDelete: e.target.value })
							}
						/>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={this.handleCloseDeleteModal}>
							Cancel
						</Button>
						<Button
							variant="danger"
							disabled={
								Number(this.state.orderIdToDelete) !== bookingData?.orderId ||
								this.state.isDeleting
							}
							onClick={this.handleDeleteBooking}
						>
							{this.state.isDeleting ? "Deleting..." : "Delete"}
						</Button>
					</Modal.Footer>
				</Modal>

				<Modal
					show={this.state.isRestoreConfirmModalOpen}
					onHide={this.handleCloseRestoreModal}
				>
					<Modal.Header>
						<Modal.Title>Restore Confirmation</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<p>Are you sure you want to restore this booking?</p>
						<p>
							Order ID: <code>{bookingData?.orderId}</code>
						</p>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={this.handleCloseRestoreModal}>
							Cancel
						</Button>
						<Button
							variant="success"
							disabled={this.state.isRestoring}
							onClick={this.handleRestoreBooking}
						>
							{this.state.isRestoring ? "Restoring..." : "Restore"}
						</Button>
					</Modal.Footer>
				</Modal>

				<Modal
					show={this.state.isReassignModalOpen}
					onHide={this.handleReassignModalClose}
					enforceFocus={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>Reassign Driver for Booking #{bookingData?.orderId}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{this.renderDriverSelect({
							value: this.state.selectedDriverId,
							onChange: (driverId) =>
								this.handleSelectDriver({ target: { value: driverId } }),
							showCurrentDriverCard: true,
						})}
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={this.handleReassignModalClose}>
							Close
						</Button>
						<Button
							variant="primary"
							onClick={this.handleReassignDriver}
							disabled={!this.state.selectedDriverId}
						>
							Confirm Reassign
						</Button>
					</Modal.Footer>
				</Modal>

				{this.renderHistoryModal(bookingData)}
				{this.renderScamRiskModal(bookingData?.scamRisk)}
				{bookingData && this.renderStatusModal(bookingData)}

				<div
					className={cx(
						s.pagecontentWrapper,
						s.widthInner,
						s.space5,
						"viewDetailsTableRTL",
					)}
				>
					<div className={s.contentBox}>
						<Row>
							<Col lg={4} md={4} sm={4} xs={4}>
								<Link to={goToBackLink} className={cx("btn btn-light mr-4")}>
									<FaArrowLeft />
									<span className="d-none d-md-inline-block ml-2">
										<FormattedMessage {...messages.goBack} />
									</span>
								</Link>
							</Col>

							<Col lg={4} md={4} sm={4} xs={4}>
								<h1
									className={cx(
										s.titleTextAdmin,
										s.space2,
										"textAlignRightRTL",
									)}
								>
									<FormattedMessage {...messages.adminBookingDetails} />
									<span className="ml-2">#{bookingData?.orderId}</span>
								</h1>
							</Col>

							<Col
								lg={4}
								md={4}
								sm={4}
								xs={4}
								className={cx(s.textAlignRight, s.space2, "textAlignLeftRTL")}
							>
								<button
									className="btn btn-light"
									onClick={this.handleOpenHistoryModal}
									type="button"
									title="Booking Activities"
								>
									<FaHistory />
									<span className="d-none d-md-inline-block ml-2">
										Booking Activities
									</span>
								</button>
							</Col>
						</Row>

						{bookingData?.deletedAt && (
							<div className="alert alert-danger p-2 m-2 text-center">
								Booking deleted{" "}
								<b title={bookingData.deletedAt}>
									{wita(bookingData.deletedAt)?.fromNow()}
								</b>
								{bookingData?.deletedAt && (
									<button
										className="btn btn-light btn-sm ml-2"
										onClick={this.handleRestoreBookingConfirmation}
										type="button"
										title="Restore booking"
									>
										<FaUndo className="mr-2" />
										Restore
									</button>
								)}
							</div>
						)}

						<div className={cx("table-responsive")}>
							<Table>
								{bookingData && (
									<tbody>
										{bookingData?.orderId &&
											this.renderInformation(
												formatMessage(messages?.orderId),
												`#${bookingData?.orderId}`,
											)}
										{bookingData.userDetails &&
											this.renderUserInformation(
												formatMessage(messages.userDetails),
												bookingData.userDetails,
											)}
										{bookingData.shopDetails &&
											this.renderUserInformation(
												formatMessage(messages.shopDetails),
												bookingData.shopDetails,
												3,
											)}
										{bookingData.deliveryPartnerDetails && (
											// this.renderUserInformation(formatMessage(messages.deliveryPartnerDetails), bookingData.deliveryPartnerDetails)

											<tr>
												<td>
													<b>
														{formatMessage(messages.deliveryPartnerDetails)}
													</b>
												</td>
												<td className="d-flex justify-content-between">
													<div className="d-flex align-items-center">
														<img
															src={bookingData.deliveryPartnerDetails.picture
																? getAvatarUrl(bookingData.deliveryPartnerDetails.picture)
																: getUiAvatarUrl(`${bookingData.deliveryPartnerDetails.firstName} ${bookingData.deliveryPartnerDetails.lastName}`)}
															alt="avatar"
															style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', marginRight: 12, flexShrink: 0 }}
														/>
														<div>
															<Link
																to={`/siteadmin/drivers/${bookingData.deliveryPartnerDetails.profileId}`}
															>
																{`${bookingData.deliveryPartnerDetails.firstName} ${bookingData.deliveryPartnerDetails.lastName}`}
															</Link>
															<br />
															{bookingData.deliveryPartnerDetails.phoneNumber}
															<br />
															{bookingData.deliveryPartnerDetails.email}
														</div>
													</div>
													<div>
														<Button
															size="sm"
															variant="light"
															onClick={this.handleReassignModalOpen}
														>
															Reassign Driver
															<FaCaretDown />
														</Button>
													</div>
												</td>
											</tr>
										)}
										{this.renderInformation(
											formatMessage(messages.typeOfDeliverly),
											bookingData.deliveryName,
										)}

										{bookingData.isDoorStepDelivery &&
											bookingData.deliveryOption &&
											this.renderInformation(
												formatMessage(messages.deliveryOption),
												getDeliveryName(bookingData.deliveryOption)
													? formatMessage(
														getDeliveryName(bookingData.deliveryOption),
													)
													: "",
											)}

										<tr>
											<td className={s.tableLabelColumn}>
												<b>{formatMessage(messages.orderStatus)}</b>
											</td>
											<td className={cx(s.lineBreak, "d-flex justify-content-between align-items-center")}>
												{this.renderBookingStatusBadge(
													bookingData.bookingStatus,
													bookingData?.deliveryPartnerDetails,
												)}
												{!bookingData.deletedAt && (
													<Button
														size="sm"
														variant="light"
														onClick={this.handleStatusModalOpen}
													>
														Change Status
														<FaCaretDown />
													</Button>
												)}
											</td>
										</tr>
										{this.renderScamRiskDetails(bookingData.scamRisk)}

										{bookingData.notes &&
											this.renderInformation(
												formatMessage(messages.remarks),
												bookingData.notes,
											)}
										<tr>
											<td className={s.tableLabelColumn}>
												<b>{formatMessage(messages.payment)}</b>
											</td>
											<td className={s.lineBreak}>
												{this.renderPaymenetStatus(bookingData.paymentStatus)}
												<span className="ml-2">
													{this.renderPaymentMethod(bookingData.paymentType)}
												</span>
											</td>
										</tr>
										{this.renderPickUpMapLink(bookingData)}
										{this.renderMapDirectionLink(bookingData)}
										{this.renderDropOffMapLink(bookingData)}

										<tr>
											<td>
												<b>{formatMessage(messages.orderCreatedAt)}</b>
											</td>
											<td>
												{wita(bookingData.bookingCreatedAt)?.format(
													"MM-DD-YYYY HH:mm:ss",
												)} &nbsp;
												<small className="text-muted">({wita(bookingData.bookingCreatedAt)?.fromNow()})</small>
											</td>
										</tr>
										{bookingData.bookingDropOffAt && (
											<tr>
												<td>
													<b>
														{formatMessage(messages.orderDeliveredAt)}
													</b>
												</td>
												<td>
													{wita(bookingData.bookingDropOffAt)?.format(
														"MM-DD-YYYY HH:mm:ss",
													)} &nbsp;
													<small className="text-muted">({wita(bookingData.bookingDropOffAt)?.fromNow()})</small>
												</td>
											</tr>
										)}
										{this.renderCompletionLocation(bookingData)}

										{this.renderInformation(
											formatMessage(messages.totalDuration),
											`${bookingData.totalDuration} ${formatMessage(messages.minutes)}`,
										)}
										{bookingData.orderNotes && (
											<tr>
												<td>
													<b>
														<FormattedMessage {...messages.orderNotes} />
													</b>
												</td>
												<td className={s.lineBreak}>
													{bookingData.orderNotes}
												</td>
											</tr>
										)}
										{this.renderInformation(
											formatMessage(messages.totalOrderedItems),
											bookingData.orderItemsCount,
										)}

										{this.renderOrderedItems(bookingData)}
										{bookingData.isDoorStepDelivery &&
											bookingData.deliveryInstruction &&
											this.renderInformation(
												formatMessage(messages.deliveryInstruction),
												bookingData.deliveryInstruction,
											)}
										{!bookingData.isDoorStepDelivery &&
											bookingData.deliveryInstruction &&
											this.renderInformation(
												formatMessage(messages.pickupInstruction),
												bookingData.deliveryInstruction,
											)}
										<tr className="bg-light">
											<td colSpan={2}>
												<FaUser className="mr-1" />
												<b>
													<FormattedMessage
														{...messages.userBillingInformation}
													/>
													:
												</b>
											</td>
										</tr>
										{this.renderAmountInformation({
											label: formatMessage(messages.subTotalLabel),
											amount: bookingData.subTotal,
											currency: bookingData.currency,
										})}

										{this.renderUserFare(bookingData)}
										{this.renderSpecialDeliveryDetails(bookingData)}

										{this.renderAmountInformation({
											label: "User Grand Total",
											amount: bookingData.userPayableFare,
											currency: bookingData.currency,
											isMinus: false,
											isBold: true,
											isGreen: true,
										})}

										<tr className="bg-light">
											<td colSpan={2}>
												<FaStoreAlt className="mr-1" />
												<b>
													<FormattedMessage
														{...messages.shopBillingInformation}
													/>
													:
												</b>
											</td>
										</tr>
										{this.renderAmountInformation({
											label: formatMessage(messages.subTotalLabel),
											amount: bookingData.subTotal,
											currency: bookingData.currency,
										})}


										{this.renderShopFare(bookingData)}


										{this.renderAmountInformation({
											label: "Total Payable to Shop",
											amount: bookingData.subTotal + bookingData.shopTotalFare,
											currency: bookingData.currency,
											isMinus: false,
											isBold: true,
											isGreen: true,
										})}

										{data.isDoorStepDelivery && (
											<>
												<tr>
													<td colSpan={2}>
														<b>
															<FormattedMessage
																{...messages.driverBillingInformation}
															/>
															:
														</b>
													</td>
												</tr>

												{this.renderAmountInformation({
													label: formatMessage(messages.deliveryFee),
													amount: bookingData.deliveryFee,
													currency: bookingData.currency,
												})}

												{this.renderAmountInformation({
													label: formatMessage(messages.driverServiceFee),
													amount: bookingData.driverServiceFare,
													currency: bookingData.currency,
													isMinus: true,
												})}
												{this.renderAmountInformation({
													label: formatMessage(messages.driverTotalFare),
													amount: bookingData.driverTotalFare,
													currency: bookingData.currency,
													isMinus: false,
													isBold: true,
												})}
											</>
										)}

										<tr className="bg-light">
											<td colSpan={2}>
												<FaPercentage className="mr-1" />
												<b>
													Driver Earning:
												</b>
											</td>
										</tr>

										{this.renderAmountInformation({
											label: "Delivery Fee",
											amount: bookingData.deliveryFee,
											currency: bookingData.currency,
										})}

										{this.renderAmountInformation({
											label: formatMessage(messages.driverServiceFee),
											amount: bookingData.driverServiceFare,
											currency: bookingData.currency,
											isMinus: true,
										})}

										{this.renderAmountInformation({
											label: "Tips",
											amount: bookingData.tips,
											currency: bookingData.currency,
											isPlus: true,
										})}

										{bookingData.deliveryName !== 'Food' && this.renderAmountInformation({
											label: `Weight Fee (${currentWeightFeeDriverShare * 100}%)`,
											amount: bookingData.weightFee * currentWeightFeeDriverShare,
											currency: bookingData.currency,
											isPlus: true,
										})}

										{/* {this.renderAmountInformation({
											label: "Share from Booking Fee",
											amount: bookingData.driverBookingEarning,
											currency: bookingData.currency,
											isPlus: true,
										})} */}

										{this.renderAmountInformation({
											label: "Parking Fee",
											amount: bookingData.parkingFee,
											currency: bookingData.currency,
											isPlus: true,
										})}

										<tr>
											<td>
												<b>Driver Total Earnings</b>
											</td>
											<td>
												<b className="text-success">
													<CurrencyConverter
														from={bookingData.currency}
														amount={driverEarnings}
													/>
												</b>

												{/* <OverlayTrigger
													trigger={["hover", "focus"]}
													key={"driver-earning-info"}
													placement={"top"}
													overlay={
														<Popover id={`driver-earning-info`}>
															<Popover.Content>
																Driver Earnings: 100% Delivery Fee
															</Popover.Content>
														</Popover>
													}
												>
													<FaInfoCircle className="ml-2 text-muted" />
												</OverlayTrigger> */}
											</td>
										</tr>

										<tr className="bg-light">
											<td colSpan={2}>
												<FaPercentage className="mr-1" />
												<b>
													<FormattedMessage {...messages.earningsMenu} />:
												</b>
											</td>
										</tr>

										{this.renderAmountInformation({
											label: formatMessage(messages.userServiceFee),
											amount: bookingData.userServiceFare,
											currency: bookingData.currency,
										})}

										{this.renderAmountInformation({
											label: "Booking Fee Discount",
											amount: bookingData.bookingFeeDiscount,
											currency: bookingData.currency,
											isMinus: true,
										})}

										{this.renderAmountInformation({
											label: `Company Booking Fee Share (${Math.round((bookingData.adminEarningsCompanyShare || 0) * 100)}%)`,
											amount: Math.round((Number(bookingData.userServiceFare || 0) - Number(bookingData.bookingFeeDiscount || 0)) * (bookingData.adminEarningsCompanyShare || 0)),
											currency: bookingData.currency,
											isPlus: true,
										})}

										{this.renderAmountInformation({
											label: formatMessage(messages.driverServiceFee),
											amount: bookingData.driverServiceFare,
											currency: bookingData.currency,
											isPlus: true,
										})}

										{bookingData.deliveryName !== 'Food' && bookingData.weightFee > 0 &&
											this.renderAmountInformation({
												label: `Weight Fee Share (${(1 - WEIGHT_FEE_DRIVER_SHARE) * 100}%)`,
												amount: bookingData.weightFee * (1 - WEIGHT_FEE_DRIVER_SHARE),
												currency: bookingData.currency,
												isPlus: true,
											})}


										<tr>
											<td>
												<b>{formatMessage(messages.earningsMenu)}</b>
											</td>
											<td>
												<b className="text-success">
													<CurrencyConverter
														from={bookingData.currency}
														amount={adminEarnings}
													/>
												</b>
												{/* <OverlayTrigger
													trigger={["hover", "focus"]}
													key={"admin-earning-info"}
													placement={"top"}
													overlay={
														<Popover id={`admin-earning-info`}>
															<Popover.Content>
																Admin Earnings: 100% of Booking Fee after
																deducting with voucher discount
															</Popover.Content>
														</Popover>
													}
												>
													<FaInfoCircle className="ml-2 text-muted" />
												</OverlayTrigger> */}
											</td>
										</tr>
										{adminOverdraft > 0 &&
											this.renderAmountInformation({
												label: formatMessage(messages.adminOverdraft),
												amount: adminOverdraft,
												currency: bookingData.currency,
												isMinus: false,
												isBold: false,
											})}
									</tbody>
								)}
							</Table>
						</div>

						{bookingData && (
							<Query
								query={getBookingReviewsQuery}
								variables={{ bookingId: bookingData.id }}
								fetchPolicy="network-only"
							>
								{({ loading: reviewsLoading, data: reviewsData }) => {
									if (reviewsLoading) return null;
									const reviews = reviewsData?.getBookingReviews?.results || [];
									if (reviews.length === 0) return null;

									const shopReview = reviews.find(r => r.userData?.userType === 3);
									const driverReview = reviews.find(r => r.userData?.userType === 2);
									const customerReview = reviews.find(r => r.userData?.userType === 1);
									const isDoorStep = bookingData.isDoorStepDelivery;

									return (
										<div className="mt-3">
											<h6 className="font-weight-bold border-bottom pb-2 mb-3">
												<FaStar className="mr-2 text-warning" />
												Reviews
											</h6>
											<Row>
												{shopReview && (
													<Col md={isDoorStep ? 6 : 12}>
														<div className="border rounded p-3 mb-3">
															<p className="font-weight-bold mb-2">Review to Shop</p>
															<StarRating
																name="shop-review"
																value={shopReview.ratings}
																editing={false}
															/>
															<p className="mt-2 mb-1 text-muted small">
																{shopReview.reviewContent}
															</p>
															<small className="text-muted">
																by{" "}
																<Link to={`/siteadmin/users/${shopReview.authorData?.profileId}`}>
																	{shopReview.authorData?.firstName || "Customer"}
																</Link>
															</small>
														</div>
													</Col>
												)}
												{isDoorStep && driverReview && (
													<Col md={6}>
														<div className="border rounded p-3 mb-3">
															<p className="font-weight-bold mb-2">Review to Driver</p>
															<StarRating
																name="driver-review"
																value={driverReview.ratings}
																editing={false}
															/>
															<p className="mt-2 mb-1 text-muted small">
																{driverReview.reviewContent}
															</p>
															<small className="text-muted">
																by{" "}
																<Link to={`/siteadmin/users/${driverReview.authorData?.profileId}`}>
																	{driverReview.authorData?.firstName || "Customer"}
																</Link>
																{" → "}
																<Link to={`/siteadmin/drivers/${driverReview.userData?.profileId}`}>
																	{driverReview.userData?.firstName || "Driver"}
																</Link>
															</small>
														</div>
													</Col>
												)}
												{isDoorStep && customerReview && (
													<Col md={6}>
														<div className="border rounded p-3 mb-3">
															<p className="font-weight-bold mb-2">Review to Customer</p>
															<StarRating
																name="customer-review"
																value={customerReview.ratings}
																editing={false}
															/>
															<p className="mt-2 mb-1 text-muted small">
																{customerReview.reviewContent}
															</p>
															<small className="text-muted">
																by{" "}
																<Link to={`/siteadmin/drivers/${customerReview.authorData?.profileId}`}>
																	{customerReview.authorData?.firstName || "Driver"}
																</Link>
																{" → "}
																<Link to={`/siteadmin/users/${customerReview.userData?.profileId}`}>
																	{customerReview.userData?.firstName || "Customer"}
																</Link>
															</small>
														</div>
													</Col>
												)}
											</Row>
										</div>
									);
								}}
							</Query>
						)}

						{bookingData && !bookingData.deletedAt && (
							<button
								className="btn btn-link text-danger"
								onClick={this.handleDeleteBookingConfirmation}
								type="button"
								title="Delete booking"
							>
								Delete Booking
							</button>
						)}
					</div>
				</div>
			</>
		);
	}
}

const mapState = (state) => ({
	locale: state.intl.locale,
});
const mapDispatch = {
	openTransactionModal,
	updatePayoutStatus,
	deleteBooking,
	restoreDeletedBooking,
	adminUpdateBookingDriver,
	adminUpdateBookingStatus,
	updateBookingRiskReview,
};

export default injectIntl(
	withStyles(s, rs)(connect(mapState, mapDispatch)(ViewBookingDetails)),
);
